import { render, staticRenderFns } from "./OffersTabsComponent.vue?vue&type=template&id=377323a9&scoped=true"
import script from "./OffersTabsComponent.vue?vue&type=script&lang=js"
export * from "./OffersTabsComponent.vue?vue&type=script&lang=js"
import style0 from "./OffersTabsComponent.vue?vue&type=style&index=0&id=377323a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377323a9",
  null
  
)

export default component.exports